import getMonth from 'date-fns/getMonth';
import getYear from 'date-fns/getYear';

import { DatePickerDate } from '../types';
import { TTranslate } from './types';

export default function getSelectableMonths({
  T,
  minDate,
  maxDate,
  currentYear,
}: {
  T: TTranslate;
  minDate?: DatePickerDate | null;
  maxDate?: DatePickerDate | null;
  currentYear?: number;
}) {
  // if the active visible year is the same as min or max we want to disable months accordingly
  const min =
    minDate && currentYear === getYear(minDate) ? getMonth(minDate) : 0;
  const max =
    maxDate && currentYear === getYear(maxDate) ? getMonth(maxDate) : 11;

  const months = [
    { key: 0, label: T.translate('JANUARY') },
    { key: 1, label: T.translate('FEBRUARY') },
    { key: 2, label: T.translate('MARCH') },
    { key: 3, label: T.translate('APRIL') },
    { key: 4, label: T.translate('MAY') },
    { key: 5, label: T.translate('JUNE') },
    { key: 6, label: T.translate('JULY') },
    { key: 7, label: T.translate('AUGUST') },
    { key: 8, label: T.translate('SEPTEMBER') },
    { key: 9, label: T.translate('OCTOBER') },
    { key: 10, label: T.translate('NOVEMBER') },
    { key: 11, label: T.translate('DECEMBER') },
  ];

  if (min === max) {
    return months.filter((m) => m.key === min);
  }

  return months.filter((m) => m.key <= max && m.key >= min);
}
